export default __webpack_public_path__ + "static/media/RhymesWeather_10.27707776.png";